import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.247.88H20.6c.82 0 1.483.678 1.483 1.516V16.04c0 .837-.664 1.516-1.483 1.516-.82 0-1.484-.679-1.484-1.516V6.056L3.446 22.067a1.461 1.461 0 0 1-2.099 0 1.54 1.54 0 0 1 0-2.143L17.02 3.912H7.247c-.82 0-1.484-.68-1.484-1.516 0-.838.664-1.516 1.484-1.516z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }